import React, { useState, useEffect } from "react";
import FieldValidity from "../../services/fieldValidity.service";
import ReCAPTCHA from 'react-google-recaptcha';
import Settings from "../../services/settings.service";
import Translation from "../../services/translation.service";
import Storage from "../../services/storage.service";

// This Component is responsible for rendering below report forms:
// 1. Spam Calls > Report by Name
// 2. Spam SMS > Report by Number

export default function ProtectionChannelSpamSMSName({
    reportSpamCall = () => { },
}) {
    let prefix = "scr_protection_channel";
    let error_prefix = "scr_protection_channel_err_";

    const getStorageValue = (key) => {
        let business = JSON.parse(Storage.get("business", true))
        let poValue = business["fraud_validation"] ? business["fraud_validation"] : "";
        if (poValue) {
            return poValue[key] ? poValue[key] : "";
        } else {
            return "";
        }

    }
    const [captchaChecked, setCaptchaChecked] = useState(false);
    const [formValid, setFormValid] = useState(false);

    const [senderName, setSenderName] = useState({
        value: "",
        valid: false,
        touched: false,
        validations: {
            requiredObject: true,
            minLength: getStorageValue("fraud_sender_name_char_limit_min"),
            maxLengthObj: getStorageValue("fraud_sender_name_char_limit_max"),
        },
        error: ""
    });

    const [senderMessage, setSenderMessage] = useState({
        value: "",
        valid: false,
        touched: false,
        validations: {
            requiredObject: true,
            minLength: getStorageValue("fraud_sms_content_char_limit_min"),
            maxLengthObj: getStorageValue("fraud_sms_content_char_limit_max")
        },
        error: ""
    });

    useEffect(() => {
        prefilledData();
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    const prefilledData = () => {
        setCaptchaChecked(false);
        let data_payload = JSON.parse(Storage.get("PrePayload"));
        if (data_payload &&
            data_payload?.UserName) {
            handleNameChange(data_payload?.UserName)
        }

        if (data_payload &&
            data_payload?.Notes
        ) {
            handleMessageChange(data_payload?.Notes)
        }
    }
    const handleNameChange = (data) => {

        // if (e.target.name === "senderName") {
        let nameValid = FieldValidity.checkFieldValidity(data, senderName.validations);
        let errorMsg = ""

        if (!nameValid?.valid && !data) {
            errorMsg = Translation.keys[error_prefix + "error_required_message"]
        } else if (!nameValid?.valid && nameValid?.type === "length" && data) {
            errorMsg = Translation.keys[error_prefix + "fraud_sender_name_char_limit_min"]
            // errorMsg = "The field must have at least 5 characters";
        } else if (!nameValid?.valid && nameValid?.type === "maxLength" && data) {
            errorMsg = Translation.keys[error_prefix + "fraud_sender_name_char_limit_max"]
            // errorMsg = "The field must have maximum 15 characters";
        } else {
            errorMsg = ""
        }

        setSenderName({
            ...senderName,
            value: data,
            valid: nameValid?.valid,
            data_submition: true,
            touched: true,
            error: errorMsg
        });
        if (nameValid?.valid && data) {
            setFormValid(true);
        } else {
            setFormValid(false);
        }
        // }
    }

    const handleMessageChange = (data) => {
        // if (e.target.name === "senderMessage") {
        let msgValid = FieldValidity.checkFieldValidity(data, senderMessage.validations);
        let errorMsg = ""
        if (!msgValid?.valid && !data) {
            errorMsg = Translation.keys[error_prefix + "error_required_message"]
        } else if (!msgValid?.valid && msgValid?.type === "length" && data) {
            errorMsg = Translation.keys[error_prefix + "fraud_sms_content_char_limit_min"]
            // errorMsg = "The field must have at least 10 characters";
        } else if (!msgValid?.valid && msgValid?.type === "maxLength" && data) {
            errorMsg = Translation.keys[error_prefix + "fraud_sms_content_char_limit_max"]
            // errorMsg = "The field must have maximum 200 characters";
        } else {
            errorMsg = ""
        }

        setSenderMessage({
            ...senderMessage,
            value: data,
            valid: msgValid?.valid,
            data_submition: true,
            touched: true,
            error: errorMsg
        });
        if (msgValid?.valid && data) {
            setFormValid(true);
        } else {
            setFormValid(false);
        }
        // }
    }

    const updateCaptcha = (value) => {
        if (value) {
            setCaptchaChecked(true);
        } else {
            setCaptchaChecked(false);
        }
    }

    const handleSubmit = () => {
        if (senderMessage?.valid && senderName?.valid && formValid) {
            let payload = {
                senderName: senderName?.value,
                senderMessage: senderMessage?.value,
            }
            reportSpamCall(formValid, payload)
        }

    }

    // Check if button should be enabled (same logic as button disabled prop)
    const isButtonEnabled = captchaChecked && formValid && senderMessage?.valid && senderName?.valid;

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'Enter' && isButtonEnabled) {
                // Don't submit if Enter is pressed in textarea
                if (event.target.tagName !== 'TEXTAREA') {
                    handleSubmit();
                }
            }
        };

        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [isButtonEnabled]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <div className="field-container">
                <label>{Translation.keys[prefix + "sender_name"]}</label>
                <input
                    className={"storefront-search-input " +
                        (!senderName.touched || (senderName.touched && senderName.valid)
                            ? "valid"
                            : "invalid") +
                        (senderName.value ? " filled" : "")
                    }
                    name="senderName"
                    type="text"
                    autoComplete="off"
                    value={senderName?.value}
                    onChange={(e) => handleNameChange(e?.target?.value)}
                    placeholder={Translation.keys[prefix + "sender_name"]}
                />
                {
                    !senderName.valid && senderName.touched && senderName.error ? <span className="error-msg">{senderName?.error}</span> : null
                }
            </div>
            <div className="field-container">
                <label>{Translation.keys[prefix + "_enter_sms_content"]}</label>
                <textarea
                    className={"storefront-search-input " +
                        (!senderMessage.touched || (senderMessage.touched && senderMessage.valid)
                            ? "valid"
                            : "invalid") +
                        (senderMessage.value ? " filled" : "")
                    }
                    placeholder={Translation.keys[prefix + "_enter_sms_content_placeholder"]}
                    name="senderMessage"
                    type="text"
                    rows={5}
                    autoComplete="off"
                    value={senderMessage?.value}
                    onChange={(e) => handleMessageChange(e?.target?.value)}
                    maxLength={getStorageValue("fraud_sms_content_char_limit_max")}
                />
                {
                    !senderMessage.valid && senderMessage.touched && senderMessage.error ? <span className="error-msg">{senderMessage?.error}</span> : null
                }
            </div>
            <div className="field-container">
                <span>{Translation.keys[prefix + "_please_check_box"]}</span>
                <ReCAPTCHA
                    sitekey={Settings.get("google_recaptcha_site_key")}
                    onChange={updateCaptcha}
                    hl={Translation.getCurrentLanguage() === "ar" ? "ar" : "en"}
                />
            </div>

            <button
                className="common-button"
                disabled={!captchaChecked || !formValid || !senderMessage?.valid || !senderName?.valid}
                onClick={() => {
                    handleSubmit()
                }}
            >
                {Translation.keys[prefix + "_submit"]}
            </button>
        </>
    )
}